import { useElementDimensions } from "hooks";
import { useState, } from "react";

export let usePresentationMode = () => {
  // TODO: this will mean every instance has a separate state, if you want to implement an override, 
  // use browser storage resource here
  let [presentationMode, setPresentationMode] = useState(false);

  let windowDimensions = useElementDimensions();

  let forcePresentationMode = windowDimensions.width > 640 // TODO: use tw-sm variable

  return [
    presentationMode || forcePresentationMode,
    setPresentationMode,
  ]
}